module.exports = __webpack_public_path__ + "static/media/Wagner Wardrobes (4).847269ad.jpg";